import localDescription from './localDescription'
import localTracks from './localTracks'
import remoteDescription from './remoteDescription'
import remoteTracks from './remoteTracksActive'
import remoteTracksAll from './remoteTracks'
import senderTracks from './senderTracks'

export default { localDescription, localTracks, remoteDescription, remoteTracks, remoteTracksAll, senderTracks }
